import { useCommonStore } from '../../stores/commonStore';
import { ToastMessage } from '../../types/common';
import { colors } from '../../utils/constants/colors';
import { Success } from '../../icons/Success';
import { Error } from '../../icons/Error';
import { Info } from '../../icons/Info';

const ToastMessageDialogue = () => {
    const toastMessage: ToastMessage | null = useCommonStore((state) => state.toastMessage);
    const setToastMessage = useCommonStore((state) => state.setToastMessage);

    const handleClose = () => {
        setToastMessage(null);
    };

    return (
        <div
            className="z-50 inline-block rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full absolute top-20 right-6"
            style={{
                backgroundColor: '#0F0D21',
                pointerEvents: toastMessage ? 'all' : 'none',
                opacity: toastMessage ? 1 : 0,
                width: 440,
                height: 100,
                color: 'white',
                padding: 16
            }}
        >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                <div style={{ display: 'flex', gap: 16 }}>
                    {toastMessage?.type === 'success' && <Success />}
                    {toastMessage?.type === 'error' && <Error />}
                    {toastMessage?.type === 'info' && <Info />}
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <h3 style={{ fontSize: 20, fontWeight: 600 }} id="modal-title">
                            {toastMessage?.message}
                        </h3>
                        {toastMessage?.description && <p style={{ color: '#F0F2F5', fontSize: 16, fontWeight: 400 }}>{toastMessage.description}</p>}
                    </div>
                </div>
                <button className="hover:text-red-700" onClick={handleClose}>
                    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.3007 5.70997C17.9107 5.31997 17.2807 5.31997 16.8907 5.70997L12.0007 10.59L7.1107 5.69997C6.7207 5.30997 6.0907 5.30997 5.7007 5.69997C5.3107 6.08997 5.3107 6.71997 5.7007 7.10997L10.5907 12L5.7007 16.89C5.3107 17.28 5.3107 17.91 5.7007 18.3C6.0907 18.69 6.7207 18.69 7.1107 18.3L12.0007 13.41L16.8907 18.3C17.2807 18.69 17.9107 18.69 18.3007 18.3C18.6907 17.91 18.6907 17.28 18.3007 16.89L13.4107 12L18.3007 7.10997C18.6807 6.72997 18.6807 6.08997 18.3007 5.70997Z" />
                    </svg>
                </button>
            </div>

            {/* <div className="flex justify-between items-center">
                <div className="sm:flex sm:items-center">
                    {toastMessage?.type === 'error' && (
                        <div className="flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10 sm:mr-4">
                            <svg className="h-6 w-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                />
                            </svg>
                        </div>
                    )}
                    <div className="mt-0 text-center sm:text-left">
                        <h3 style={{fontSize: 20, fontWeight: 600}} id="modal-title">
                            {toastMessage?.message}
                        </h3>
                    </div>
                </div>
                <button className="hover:text-blue-700" onClick={handleClose}>
                    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.3007 5.70997C17.9107 5.31997 17.2807 5.31997 16.8907 5.70997L12.0007 10.59L7.1107 5.69997C6.7207 5.30997 6.0907 5.30997 5.7007 5.69997C5.3107 6.08997 5.3107 6.71997 5.7007 7.10997L10.5907 12L5.7007 16.89C5.3107 17.28 5.3107 17.91 5.7007 18.3C6.0907 18.69 6.7207 18.69 7.1107 18.3L12.0007 13.41L16.8907 18.3C17.2807 18.69 17.9107 18.69 18.3007 18.3C18.6907 17.91 18.6907 17.28 18.3007 16.89L13.4107 12L18.3007 7.10997C18.6807 6.72997 18.6807 6.08997 18.3007 5.70997Z" />
                    </svg>
                </button>
                
            </div>
            {toastMessage?.description && (
                                <p style={{color: '#F0F2F5', fontSize: 16, fontWeight: 400, paddingLeft: 4}}>{toastMessage.description}</p>
                        )} */}
        </div>
    );
};

export default ToastMessageDialogue;
